export default __webpack_public_path__ + "static/media/sign-up.8e8704b8.png";